// src/components/DesignationMemberCard/DesignationMemberCard.js
import React from "react";
import { Card, Badge } from "react-bootstrap";
import "./DesignationMemberCard.css";

const DesignationMemberCard = ({ designation, member, level }) => {
  return (
    // <Card className="h-100 shadow-sm designation-card">
    //   <Card.Body className="p-3 d-flex flex-column">
    //     <div className="text-center mb-3">
    //       <div className="designation-badge mb-2">
    //         <Badge bg="primary" className="text-uppercase px-3 py-2">
    //           {designation.name}
    //         </Badge>
    //       </div>
    //       <Badge bg="secondary" className="level-badge">
    //         {level} Level
    //       </Badge>
    //     </div>

    //     <div className="d-flex flex-column align-items-center mb-3">
    //       <img
    //         src={`${member.photo_url}`}
    //         alt={member.name}
    //         className="member-img rounded mb-3"
    //         onError={(e) => {
    //           e.target.src =
    //             "https://via.placeholder.com/150x150/f5f5f5/999999?text=No+Image";
    //         }}
    //       />
    //       <h5 className="mb-1 text-center fw-bold">{member.name}</h5>
    //       <p className="text-muted mb-2 text-center">{member.profession}</p>
    //     </div>

    //     <div className="member-details">
    //       <div className="detail-item">
    //         <i className="bi bi-person-badge-fill text-primary"></i>
    //         <span>ID: {member.registration_id}</span>
    //       </div>

    //       {/* <div className="detail-item">
    //         <i className="bi bi-telephone-fill text-primary"></i>
    //         <span>{member.mobile_no}</span>
    //       </div> */}

    //       <div className="detail-item">
    //         <i className="bi bi-geo-alt-fill text-primary"></i>
    //         <span>
    //           {member.block && `${member.block}, `}
    //           {member.district && `${member.district}, `}
    //           {member.state}
    //         </span>
    //       </div>
    //     </div>
    //   </Card.Body>
    // </Card>
    <Card className="vice-president-card" style={{ minHeight: "100%" }}>
      <div className="card-content-wrapper">
        <div className="vp-image-container">
          <img
            src={`https://manavadhikarforum.in${member.photo_url}`}
            alt={member.name}
            className="vp-profile-img"
          />
        </div>
        <Card.Body className="vp-details-container">
          <h5 className="vp-name">{member.name.toUpperCase()}</h5>
          <p className="vp-profession">{member.profession.toUpperCase()}</p>
          <p className="vp-designation">
            {level} {designation.name}
          </p>
          <div className="vp-details">
            <p>
              <strong>Registration ID:</strong>{" "}
              {member.registration_id.toUpperCase()}
            </p>
            <p>
              <strong>District:</strong> {member.district}
            </p>
            <p>
              <strong>State:</strong> {member.state}
            </p>
          </div>
        </Card.Body>
      </div>
    </Card>
  );
};

export default DesignationMemberCard;
